import { render } from "./WalletTab.vue?vue&type=template&id=0de867e1&scoped=true"
import script from "./WalletTab.vue?vue&type=script&lang=js"
export * from "./WalletTab.vue?vue&type=script&lang=js"

import "./WalletTab.vue?vue&type=style&index=0&id=0de867e1&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0de867e1"]])

export default __exports__